import { Autocomplete, Box, TableRow, TextField } from "@mui/material";
import React, { useEffect } from "react";
import Button from "@mui/material/Button";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import TablePagination from "@mui/material/TablePagination";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import SearchIcon from "@mui/icons-material/Search";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import ListWrap from "../commonComponent/listWrap";
import { getFormattedDates } from "../../utils/utils";
import { BASE_URL } from "../../global";
import moment from "moment";
import RecalibExcelDownload from "./recalbe";
import axiosWithToken from "../../utils/components/axiosTokenConfig";
import { parseRange } from "../../utils/components/accuracyandlcandrangesshow";
const notNeededColumn = ["id", "status", "type","clientId","recalibrated_ids","pending_ids"];

const ReCalibrationReport = () => {
  const [from, setFrom] = React.useState(null);
  const [to, setTo] = React.useState(null);
  const [searched, setSearched] = React.useState(false);
  const [data, setData] = React.useState([]);
  const [instrumentData, setInstrumentData] = React.useState([]);
  const [pendingData, setPendingData] = React.useState([]);
  const [rowsPerPage, setRowsPerPage] = React.useState(30);
  const [page, setPage] = React.useState(0);
  const [customer, setCustomer] = React.useState([]);
  const [selectedClients, setSelectedClients] = React.useState([]);

  const _clientId = localStorage.getItem("clientId");
  const _userType = localStorage.getItem("type");

  // Fetch client list
  const getCustomer = async () => {
    let endPoint =
      _userType == "3"
        ? `clients/${_clientId}?_where=(status,eq,1)`
        : `clients?_where=(status,eq,1)`;

    try {
      const res = await axiosWithToken.get(BASE_URL + endPoint);
      setCustomer(res.data);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getCustomer();
  }, []);

  const getData = async () => {
    const url = BASE_URL;
    let whereConditions = "WHERE c.status != -1 AND c.nextDueDate IS NOT NULL";

    if (selectedClients.length > 0 && !selectedClients.includes("all")) {
      const ids = selectedClients.join(",");
      whereConditions += ` AND c.clientId IN (${ids})`;
    }

  const hasRange = to != null && from != null;
  let summaryDateFilter = "";
  let fromDate = "";
  let toDate = "";

  if (hasRange) {
    const f = getFormattedDates(from, to);
    fromDate = f.fromDate;
    toDate = f.toDate;
    summaryDateFilter = ` AND DATE(c.nextDueDate) BETWEEN '${fromDate}' AND '${toDate}'`;
  } else {
    summaryDateFilter = ` AND DATE(c.nextDueDate) <= CURDATE()`;
  }

  // ------------------------------------------------
  // SUMMARY QUERY - Now returns IDs for each category
  // ------------------------------------------------
  const summaryQuery = {
    query: `
      SELECT 
        c.clientId,
        c.companyName,
        c.client_address,
        COUNT(DISTINCT CONCAT(
          c.DUCID, '|', c.instrumentId, '|',
          COALESCE(TRIM(c.serialNumber), ''), '|',
          COALESCE(TRIM(c.ranges), ''), '|',
          COALESCE(TRIM(c.lc), '')
        )) AS total_due_instruments,
        
        -- Recalibrated IDs
        GROUP_CONCAT(
          DISTINCT CASE 
            WHEN EXISTS (
              SELECT 1 FROM certificatesView newer
              WHERE newer.clientId = c.clientId
                AND newer.instrumentId = c.instrumentId
                AND newer.DUCID = c.DUCID
                AND COALESCE(TRIM(newer.serialNumber), '') = COALESCE(TRIM(c.serialNumber), '')
                AND COALESCE(TRIM(newer.ranges), '') = COALESCE(TRIM(c.ranges), '')
                AND COALESCE(TRIM(newer.lc), '') = COALESCE(TRIM(c.lc), '')
                AND newer.nextDueDate IS NOT NULL
                AND c.nextDueDate IS NOT NULL
                AND DATE(newer.nextDueDate) > DATE(c.nextDueDate)
                AND newer.id > c.id
            )
            THEN c.id
            ELSE NULL
          END
        ) AS recalibrated_ids,
        
        SUM(
          CASE 
            WHEN EXISTS (
              SELECT 1 FROM certificatesView newer
              WHERE newer.clientId = c.clientId
                AND newer.instrumentId = c.instrumentId
                AND newer.DUCID = c.DUCID
                AND COALESCE(TRIM(newer.serialNumber), '') = COALESCE(TRIM(c.serialNumber), '')
                AND COALESCE(TRIM(newer.ranges), '') = COALESCE(TRIM(c.ranges), '')
                AND COALESCE(TRIM(newer.lc), '') = COALESCE(TRIM(c.lc), '')
                AND newer.nextDueDate IS NOT NULL
                AND c.nextDueDate IS NOT NULL
                AND DATE(newer.nextDueDate) > DATE(c.nextDueDate)
                AND newer.id > c.id
            )
            THEN 1
            ELSE 0
          END
        ) AS total_recalibrated_instruments,
        
        -- Pending IDs
        GROUP_CONCAT(
          DISTINCT CASE 
            WHEN NOT EXISTS (
              SELECT 1 FROM certificatesView newer
              WHERE newer.clientId = c.clientId
                AND newer.instrumentId = c.instrumentId
                AND newer.DUCID = c.DUCID
                AND COALESCE(TRIM(newer.serialNumber), '') = COALESCE(TRIM(c.serialNumber), '')
                AND COALESCE(TRIM(newer.ranges), '') = COALESCE(TRIM(c.ranges), '')
                AND COALESCE(TRIM(newer.lc), '') = COALESCE(TRIM(c.lc), '')
                AND newer.nextDueDate IS NOT NULL
                AND DATE(newer.nextDueDate) > CURDATE()
                AND newer.id > c.id
            )
            THEN c.id
            ELSE NULL
          END
        ) AS pending_ids,
        
        SUM(
          CASE 
            WHEN NOT EXISTS (
              SELECT 1 FROM certificatesView newer
              WHERE newer.clientId = c.clientId
                AND newer.instrumentId = c.instrumentId
                AND newer.DUCID = c.DUCID
                AND COALESCE(TRIM(newer.serialNumber), '') = COALESCE(TRIM(c.serialNumber), '')
                AND COALESCE(TRIM(newer.ranges), '') = COALESCE(TRIM(c.ranges), '')
                AND COALESCE(TRIM(newer.lc), '') = COALESCE(TRIM(c.lc), '')
                AND newer.nextDueDate IS NOT NULL
                AND DATE(newer.nextDueDate) > CURDATE()
                AND newer.id > c.id
            )
            THEN 1
            ELSE 0
          END
        ) AS pending_recalibrations
      FROM certificatesView c
      ${whereConditions}
      ${summaryDateFilter}
      GROUP BY c.clientId, c.companyName, c.client_address
      ORDER BY c.clientId;
    `,
  };

  try {
    // First fetch summary to get IDs
    const summaryRes = await axiosWithToken.post(url + "dynamic", summaryQuery);
    setData(summaryRes.data);

    // Collect all recalibrated and pending IDs
    const allRecalibratedIds = [];
    const allPendingIds = [];

    summaryRes.data.forEach(row => {
      if (row.recalibrated_ids) {
        const ids = row.recalibrated_ids.split(',').filter(id => id);
        allRecalibratedIds.push(...ids);
      }
      if (row.pending_ids) {
        const ids = row.pending_ids.split(',').filter(id => id);
        allPendingIds.push(...ids);
      }
    });

    // ------------------------------------------------
    // RECALIBRATED QUERY - Using IDs from summary
    // ------------------------------------------------
    let recalibratedData = [];
    if (allRecalibratedIds.length > 0) {
      const recalibratedQuery = {
        query: `SELECT  c.companyName, c.instrumentName, c.ranges, c.lc, c.DUCID, c.serialNumber, c.locationOfInstrument,
            DATE_FORMAT(c.calibrationDate, '%d-%m-%Y') AS oldCalibrationDate,
            DATE_FORMAT(c.nextDueDate, '%d-%m-%Y') AS oldNextDueDate,
            DATE_FORMAT(newer.calibrationDate, '%d-%m-%Y') AS recalibrationDate,
            DATE_FORMAT(newer.nextDueDate, '%d-%m-%Y') AS newNextDueDate
          FROM certificatesView c
          LEFT JOIN certificatesView newer ON (
            newer.clientId = c.clientId
            AND newer.instrumentId = c.instrumentId
            AND newer.DUCID = c.DUCID
            AND COALESCE(TRIM(newer.serialNumber), '') = COALESCE(TRIM(c.serialNumber), '')
            AND COALESCE(TRIM(newer.ranges), '') = COALESCE(TRIM(c.ranges), '')
            AND COALESCE(TRIM(newer.lc), '') = COALESCE(TRIM(c.lc), '')
            AND newer.nextDueDate IS NOT NULL
            AND DATE(newer.nextDueDate) > DATE(c.nextDueDate)
            AND newer.id > c.id
          )
          WHERE c.id IN (${allRecalibratedIds.join(',')})
          ORDER BY c.clientId, c.instrumentName;
        `,
      };

      const recalibratedRes = await axiosWithToken.post(url + "dynamic", recalibratedQuery);
      recalibratedData = recalibratedRes.data.map(item => ({
        ...item,
        ranges: parseRange(item.ranges),
        lc: parseRange(item.lc),
      }));
    }
    setInstrumentData(recalibratedData);

    // ------------------------------------------------
    // PENDING QUERY - Using IDs from summary
    // ------------------------------------------------
    let pendingData = [];
    if (allPendingIds.length > 0) {
      const pendingQuery = {
        query: `SELECT  c.companyName, c.instrumentName, c.ranges, c.lc, c.DUCID, c.serialNumber, c.locationOfInstrument,
            DATE_FORMAT(c.calibrationDate, '%d-%m-%Y') AS calibrationDate,
            DATE_FORMAT(c.nextDueDate, '%d-%m-%Y') AS nextDueDate
          FROM certificatesView c
          WHERE c.id IN (${allPendingIds.join(',')})
          ORDER BY c.clientId, c.instrumentName;
        `,
      };

      const pendingRes = await axiosWithToken.post(url + "dynamic", pendingQuery);
      pendingData = pendingRes.data.map(item => ({
        ...item,
        ranges: parseRange(item.ranges),
        lc: parseRange(item.lc),
      }));
      }
      setPendingData(pendingData);

    } catch (err) {
      console.error("Error fetching recalibration data:", err);    
    }
  };

  const search = () => {
    setSearched(true);
    getData();
  };

  const clearSearch = () => {
    setSearched(false);
    setFrom(null);
    setTo(null);
    setSelectedClients([]);
    setData([]);
    setInstrumentData([]);
  };

  // Prepare options (add "Select All")
  const options = [
    { id: "all", label: "Select All Clients" },
    ...customer.map((c) => ({
      id: c.id,
      label:
        c.companyName + (c.uniCode ? ` (${c.uniCode})` : ""),
    })),
  ];

  return (
    <ListWrap>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 1.5,
          alignItems: "flex-end",
          justifyContent: "flex-start",
        }}
      >
        <Box
          sx={{
            flex: {
              xs: "1 1 100%",
              sm: "1 1 calc(50% - 12px)",
              md: "0 0 280px",
            },
            maxWidth: {
              xs: "100%",
              sm: "none",
              md: 280,
            },
          }}
        >
          <Autocomplete
            multiple
            size="small"
            className="Listinputcss"
            sx={{ width: "100%", m: 0 }}
            options={options}
            limitTags={2}
            value={options.filter((opt) => selectedClients.includes(opt.id))}
            renderInput={(params) => <TextField {...params} label="Select Clients" />}
            onChange={(event, values) => {
              const ids = values.map((v) => v.id);

              if (ids.includes("all")) {
                setSelectedClients(["all", ...customer.map((c) => c.id)]);
              } else {
                setSelectedClients(ids);
              }
              setSearched(false);
            }}
          />
        </Box>
        <Box
          sx={{
            flex: {
              xs: "1 1 100%",
              sm: "1 1 calc(50% - 12px)",
              md: "0 0 210px",
            },
            maxWidth: {
              xs: "100%",
              sm: "none",
              md: 210,
            },
          }}
        >
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              slotProps={{ textField: { size: "small", fullWidth: true } }}
              className="Listinputcss"
              label="From"
              value={from ? new Date(from) : null}
              inputFormat="dd/MM/yyyy"
              format="dd/MM/yyyy"
              onChange={(newValue) => {
                setFrom(newValue);
                setSearched(false);
              }}
              renderInput={(params) => <TextField {...params} size="small" />}
            />
          </LocalizationProvider>
        </Box>
        <Box
          sx={{
            flex: {
              xs: "1 1 100%",
              sm: "1 1 calc(50% - 12px)",
              md: "0 0 210px",
            },
            maxWidth: {
              xs: "100%",
              sm: "none",
              md: 210,
            },
          }}
        >
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              slotProps={{ textField: { size: "small", fullWidth: true } }}
              className="Listinputcss"
              label="To"
              value={to ? new Date(to) : null}
              inputFormat="dd/MM/yyyy"
              format="dd/MM/yyyy"
              onChange={(newValue) => {
                setTo(newValue);
                setSearched(false);
              }}
              renderInput={(params) => <TextField {...params} size="small" />}
            />
          </LocalizationProvider>
        </Box>
        <Box>
          <Button
            variant="contained"
            size="small"
            className="Listinputcss"
            color={searched ? "error" : "primary"}
            sx={{ m: 0 }}
            // disabled={!(from && to)}
            onClick={() => {
              searched ? clearSearch() : search();
            }}
          >
            {searched ? <RestartAltIcon /> : <SearchIcon />}
          </Button>
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "stretch",
            "& > div > button": {
              marginLeft: "0px !important",
            },
          }}
        >
          <RecalibExcelDownload finalData={data} notNeededColumn={notNeededColumn} 
          secondTable={instrumentData}
          thirdTable={pendingData}
          />
        </Box>
        {/* <Box>
           <Button
            variant="contained"
            color="secondary"
            size="small"
            onClick={downloadPDF}
            disabled={!data.length}
          >
            Download PDF
          </Button>
        </Box> */}
      </Box>
      <br />

      {/*  Summary Table */}
      <h4>Recalibration Summary</h4>
      <TableContainer>
        <Table size="small" stickyHeader>
          <TableRow>
            <TableCell><b>Sr. No.</b></TableCell>
            <TableCell><b>Client Name</b></TableCell>
            <TableCell><b>Client Address</b></TableCell>
            <TableCell><b>Total Due</b></TableCell>
            <TableCell><b>Recalibrated</b></TableCell>
            <TableCell><b>Pending</b></TableCell>
          </TableRow>
          <TableBody>
            {data.length > 0 ? (
              data.map((row, i) => (
                <TableRow key={i}>
                  <TableCell>{i + 1}</TableCell>
                  <TableCell>{row.companyName}</TableCell>
                  <TableCell>{row.client_address}</TableCell>
                  <TableCell>{row.total_due_instruments}</TableCell>
                  <TableCell>{row.total_recalibrated_instruments}</TableCell>
                  <TableCell>{row.pending_recalibrations}</TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  No Data Found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <br />

      {/*  Table 2: Recalibrated Instruments */}
      {/* <h4>Recalibrated Instruments</h4>
      <TableContainer>
        <Table size="small" stickyHeader>
          <TableRow>
            <TableCell><b>Sr. No.</b></TableCell>
            <TableCell><b>Client Name</b></TableCell>
            <TableCell><b>Instrument Name</b></TableCell>
            <TableCell><b>Ranges</b></TableCell>
            <TableCell><b>LC</b></TableCell>
            <TableCell><b>DUC ID</b></TableCell>
            <TableCell><b>Serial No.</b></TableCell>
            <TableCell><b>Location</b></TableCell>
            <TableCell><b>Old Calibration Date</b></TableCell>
            <TableCell><b>Old Due Date</b></TableCell>
            <TableCell><b>Recalibration Date</b></TableCell>
            <TableCell><b>New Due Date</b></TableCell>
          </TableRow>
          <TableBody>
            {instrumentData.length > 0 ? (
              instrumentData.map((row, i) => (
                <TableRow key={i}>
                  <TableCell>{i + 1}</TableCell>
                  <TableCell>{row.companyName}</TableCell>
                  <TableCell>{row.instrumentName}</TableCell>
                  <TableCell>{row.ranges}</TableCell>
                  <TableCell>{row.lc}</TableCell>
                  <TableCell>{row.DUCID}</TableCell>
                  <TableCell>{row.serialNumber}</TableCell>
                  <TableCell>{row.locationOfInstrument}</TableCell>
                  <TableCell>{row.oldCalibrationDate}</TableCell>
                  <TableCell>{row.oldNextDueDate}</TableCell>
                  <TableCell>{row.recalibrationDate}</TableCell>
                  <TableCell>{row.newNextDueDate}</TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={12} align="center">
                  No Recalibrated Instruments Found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer> */}

      <br />

      {/*  Table 3: Pending Instruments */}
      {/* <h4>Pending Recalibrations</h4>
      <TableContainer>
        <Table size="small" stickyHeader>
          <TableRow>
            <TableCell><b>Sr. No.</b></TableCell>
            <TableCell><b>Client Name</b></TableCell>
            <TableCell><b>Instrument Name</b></TableCell>
            <TableCell><b>Ranges</b></TableCell>
            <TableCell><b>LC</b></TableCell>
            <TableCell><b>DUC ID</b></TableCell>
            <TableCell><b>Serial No.</b></TableCell>
            <TableCell><b>Location</b></TableCell>
            <TableCell><b>Calibration Date</b></TableCell>
            <TableCell><b>Next Due Date</b></TableCell>
          </TableRow>
          <TableBody>
            {pendingData.length > 0 ? (
              pendingData.map((row, i) => (
                <TableRow key={i}>
                  <TableCell>{i + 1}</TableCell>
                  <TableCell>{row.companyName}</TableCell>
                  <TableCell>{row.instrumentName}</TableCell>
                  <TableCell>{row.ranges}</TableCell>
                  <TableCell>{row.lc}</TableCell>
                  <TableCell>{row.DUCID}</TableCell>
                  <TableCell>{row.serialNumber}</TableCell>
                  <TableCell>{row.locationOfInstrument}</TableCell>
                  <TableCell>{row.calibrationDate}</TableCell>
                  <TableCell>{row.nextDueDate}</TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={10} align="center">
                  No Pending Instruments Found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer> */}
    </ListWrap>
  );
};

export default ReCalibrationReport;
